import script from "./AdminSidebarExpanded.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminSidebarExpanded.vue?vue&type=script&setup=true&lang=js"

import "./AdminSidebarExpanded.vue?vue&type=style&index=0&id=8cfd8808&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8cfd8808"]])

export default __exports__